import type { AreaOfDestination_Top } from 'gw-edge-client/dist/types/dto/pc/typekey';
import type { TravelOnsaDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/onsa/travel';
import { Grid, GridItem, RadioField, RadioInput } from '@flos/react-ui';
import { useState } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { useUpdateCoveragePackageInformation } from '../../../../recoil/hooks/useUpdateCoveragePackageInformation';
import { useHippoText } from '../../../../hooks/useHippoText';
import { areaDestination, getOnsaCoverable } from '../../../../utils/coverablesUtil';
import { getOnsaCurrentProductSelector } from '../../../../recoil/selectors/getOnsaCurrentProductSelector';
import { useUpdateCoverableInformation } from '../../../../recoil/hooks/useUpdateCoverableInformation';
import { allCoverablesOnsaAtom } from '../../../../recoil/atoms/allCoverablesOnsaAtom';
import { refreshCoveragePackagePricesAtom } from '../../../../recoil/atoms/refreshCoveragePackagePricesAtom';

const TravelPackageToggle = ({
    isLoading,
    setIsLoading
}: {
    isLoading: boolean;
    setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
}): React.JSX.Element => {
    const getHippoText = useHippoText();
    const currentProduct = useRecoilValue(getOnsaCurrentProductSelector);
    const { flavourName = '', fixedId = '' } = currentProduct ?? {};
    const coverables = useRecoilValue(allCoverablesOnsaAtom);
    const coverable = getOnsaCoverable(coverables, flavourName, fixedId) as TravelOnsaDTO;
    const [switchValue, setSwitchValue] = useState(
        coverable.areaDestination ?? areaDestination.OnlyEurope
    );
    const refreshCoveragePackagePrices = useSetRecoilState(refreshCoveragePackagePricesAtom);
    const { updateCoverableInformation } = useUpdateCoverableInformation();
    const { updateCoveragePackageInformation } =
        useUpdateCoveragePackageInformation<TravelOnsaDTO>();

    const toggleAreaOfDestination = (areaOfDestination: AreaOfDestination_Top): void => {
        setIsLoading(true);
        updateCoverableInformation({
            areaDestination: areaOfDestination
        });
        void updateCoveragePackageInformation({ areaDestination: areaOfDestination }).then(() => {
            refreshCoveragePackagePrices({});
            setIsLoading(false);
        });
    };

    return (
        <Grid className="u-spacing-inset-bottom-7">
            <GridItem colStart={5} span={4}>
                <RadioField
                    variant="button-toolbar"
                    value={switchValue}
                    stacked={false}
                    disabled={isLoading}
                    onChange={(event) => {
                        toggleAreaOfDestination(event.target.value as AreaOfDestination_Top);
                        setSwitchValue(event.target.value as AreaOfDestination_Top);
                    }}
                >
                    <RadioInput
                        value={areaDestination.Worldwide}
                        label={getHippoText('DSS-COVERAGE-PACKAGE-PAGE-WORLDWIDE')}
                    />
                    <RadioInput
                        value={areaDestination.OnlyEurope}
                        label={getHippoText('DSS-COVERAGE-PACKAGE-PAGE-EUROPE-ONLY')}
                    />
                </RadioField>
            </GridItem>
        </Grid>
    );
};

export default TravelPackageToggle;
